/* tslint:disable */
export enum SubscriptionType {Trial = "TRIAL",Regular = "REGULAR",Voucher = "VOUCHER",None = "NONE",Unlimited = "UNLIMITED"}
